module.exports = __webpack_public_path__ + "img/chehulu5.dbf24b83.jpg";